import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Name", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Used Prototype Id", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("dt", null, "Display Type", -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dt", null, "Status", -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", null, "From Time", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", null, "To Time", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("dt", null, "Expected Package", -1)
const _hoisted_13 = { class: "card-footer bg-white border border-light" }
const _hoisted_14 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_simple_table = _resolveComponent("app-simple-table")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Promotion Item Detail "
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.id), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.name), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.prototypeId), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.Options.DisplayType, _ctx.model.displayType)
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.Options.Status, _ctx.model.status)
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.fromTime)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.toTime)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.expectedPackage), 1)
          ])
        ])
      ]),
      _createVNode(_component_app_simple_table, {
        items: _ctx.model.personas,
        fields: ['rfmPersonaName', 'packageId', 'price', 'credit', 'rate']
      }, null, 8, ["items"]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_app_button, {
            name: "Edit",
            theme: "info",
            icon: "fa-edit",
            to: { name: _ctx.ROUTE_NAME_PROMOTION.ITEM.EDIT, params: { id: _ctx.model.id } }
          }, null, 8, ["to"]),
          _createVNode(_component_app_button, {
            name: "Translate",
            theme: "info",
            icon: "fa-language",
            to: { name: _ctx.ROUTE_NAME_PROMOTION.ITEM.TRANSLATE, params: { id: _ctx.model.id } }
          }, null, 8, ["to"]),
          (_ctx.model.canEnable)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 0,
                name: "Enable",
                theme: "success",
                icon: "fa-play",
                onClick: _ctx.actions.enable
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.model.canDisable)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 1,
                name: "Disable",
                theme: "success",
                icon: "fa-stop",
                onClick: _ctx.actions.disable
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.model.canDelete)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 2,
                name: "Delete",
                theme: "danger",
                icon: "fa-trash-alt",
                onClick: _ctx.actions.remove
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}